<template>
  <div class="container-fluid">
    <div v-if="currentLng === 'en'">
    <h2 class="text-center terms-header">Terms and Condition</h2><br>
    <div class="row">
      <div class="col-md-12 mobile-container">
        <div class="card">

          <div style="text-align: center;"><h4>Welcome to Universtage.com!</h4></div>

          <p>
            Before using the site and other products that we offer (Universtage Telegram Bot, etc.), we recommend that you read the text of this condition.
          </p>
          

          <h4>Our mission</h4>
          <p>
            Create a platform to improve the efficiencies of job searching for artists (circus, musicians, dancers, vocalists, etc.), and of talent searching for the venues/employers (directors, circus owners, shows, etc.) and agents. Provide access to information found both inside and outside the Universtage system, so that artists and employers can sign contracts with the maximum benefit for both sides.
          </p>

          <h4>Security</h4>
          <p>
            The administration of Universtage.com takes the necessary adequate measures to minimize the risk and prevent unauthorized access, unauthorized use and distortion of your personal data.
          </p>

          <h4>Minors</h4>
          <p>
            Universtage.com does not accept any information from persons under the age of 13. 
            Universtage.com accepts information from persons over 13, but under 18 only with the consent of their parents or legal guardians.
          </p>

          <h4>Data usage </h4>
          <p>
            The Universtage.com team is obliged to use the data of users solely for the professional benefit of the User, i.e. to support a faster and mutually beneficial conclusion of contracts between artists and their employers.
          </p>

          <h4>Terms and conditions of use of the site</h4>
          <p>
            The following rules represent the agreement between administration of Universtage.com and the User of Web-server <a href="https://www.universtage.com">www.universtage.com</a> (hereinafter referred to as the Site).
          </p>

          <p class="bold">1. Duties of the user</p>
          <p>By accessing, visiting, or making use of this Site, you accept the present “Conditions of Use”</p>
          <p>1.1. Do not be fooled by other users or the site administration.</p>
          <p>1.2. Do not create multiple accounts on the Site, if in fact they belong to the same employer or a private person.</p>
          <p>1.3. Do not knowingly post false or poor quality information.</p>
          <p>1.4. Post job only in the city in which the employee will actually work.</p>
          <p>1.5. Not to publish insults, obscene statements, and other materials that are harmful to the Company or third parties.</p>
          <p>1.6. Do not place on the site information that may relate to the collection and storage of personal data of other users.</p>
          <p>1.7. User agrees that it is solely responsible for the information published on the Site, including compliance with its legal requirements,
            copyright compliance, authorized use of the names of firms, the use of logos, trademarks for goods and services (trademarks) and also for the
            rights of third parties in connection with the placement of information on the Site. In the case of receipt of claims from third parties relating
            to the content posted by users, the User agrees to own and at their own expense to settle these claims.</p>
          <p>1.8. User agrees to use the Site in accordance with this agreement, as well as current and applicable laws in this area.</p>

          <p class="bold">2. Limitation of liability</p>
          <p>The Company is not liable for:</p>
          <p>2.1. For the content published by Users.</p>
          <p>2.2. For causing harm and any other damages that may arise using the Site. </p>

          <p class="bold">3. Administration Rights</p>
          <p>Website reserves the right to:</p>
          <p>3.1. Modify the Site at its own discretion.</p>
          <p>3.2. Edit or delete materials published by the User on the Site, if they do not comply with the terms of this Agreement, are harmful to the Company or third parties, as well as in its sole discretion, without giving any reason.</p>
          <p>
            3.3. Use the materials published by the User on the Site and are in the public domain, in particular, to post materials on partner sites in order to help the user professional benefits.
          </p>
          <p>3.4. Amend this Agreement unilaterally. A user is notified of the changed conditions of the Agreement from the date of publication of the amended version of this Agreement on the Site <a href="https://www.universtage.com/terms-and-condition">www.universtage.com/terms-and-condition</a></p>

         
        </div>
      </div>
    </div>
    </div>
    <div v-if="currentLng === 'ru'">
      <h2 class="text-center terms-header">Правила и Условия</h2><br>
      <div class="row">
        <div class="col-md-12 mobile-container">
          <div class="card">
            <div style="text-align: center;"><h4>Добро пожаловать на Universtage.com!</h4></div>

            <p>
              Перед начало пользования сайтом и другимаи продуктами которые мы предлагаем (Universtage Telegram Bot и др.), рекомендуем прочитать текст данного условия.
            </p>
           

            <h4>Наша миссия</h4>
            <p>
              Улучшить посредством автоматизации поиск работы артистам (цирковым артистам, музыкантам, танцорам, вокалистам и др.), а работодателям (режиссерам, владельцам цирков, шоу и др.) и агентам  улучшить процесс поиска артистов.  
              Для этой цели мы предоставляем Вам возможность пользоваться необходимой информацией как внутри системы Universtage, так и вне ее, что позволит  заключать контракты с максимальной выгодой как для артистов, так и для работодателей.
            </p>

            <h4>Безопасность</h4>
            <p>
              Администрация Universtage.com принимает необходимые адекватные меры для минимизации риска и предотвращения несанкционированного доступа, несанкционированного использования и искажения Ваших персональных данных.
            </p>

            <h4>Несовершеннолетние</h4>
            <p>
              Сайт Universtage.com не принимает никакой информации от лиц моложе 13 лет. 
              Сайт Universtage.com принимает информацию от лиц старше 13 лет, но моложе 18 лет только при согласии их родителей или законных опекунов.
            </p>

            <h4>Использование данных</h4>
            <p>
              Команда Universtage.com обязуется использовать даные пользователей исключительно для их профессиональной пользы, то есть быстрого и выгодного заключения договоров между артистами и их работодателями. Подробности о типах собираемой информации и ее обработке вы найдете ниже в разделе "Политика конфиденциальности".
            </p>

            <h4>Правила и условия использования сайта</h4>
            <p>
              Указанные ниже правила представляют собой соглашение между администрацией Universtage.com и пользователем веб-сайта <a href="https://www.universtage.com">www.universtage.com</a> (далее Сайта).
            </p>

            <p class="bold">1. Обязанности пользователя</p>
            <p>Принимая данное Соглашение, пользователь обязуется в полной мере следовать данным правилам при работе с сайтом.</p>
            <p>1.1. Не вводить в заблуждение других пользователей либо администрацию сайта.</p>
            <p>1.2. Не создавать несколько учетных записей на сайте, если фактически они принадлежат одному и тому же лицу.</p>
            <p>1.3. Не размещать заведомо некачественную либо фальшивую информацию.</p>
            <p>1.4. Публиковать вакансии только в тот город и страну, в котором фактически будет работать артист.</p>
            <p>1.5. Не публиковать оскорбления, нецензурные высказывания, и другие материалы, которые наносят вред кому-либо.</p>
            <p>1.6. Не размещать на сайте информацию, которая может относиться к сбору и хранению персональных данных о других пользователях.</p>
            <p>1.7. Пользователь соглашается с тем, что он несет полную ответственность за информацию, размещаемую им на Сайте, в том числе за соответствие ее требованиям законодательства, соблюдение авторских прав, санкционированное использование наименований фирм, использование логотипов, знаков для товаров и услуг (торговых марок), а также за соблюдение прав третьих лиц в связи с размещением информации на Сайте. В случае поступления претензий от третьих лиц, связанных с размещенной Пользователем информации, Пользователь обязуется самостоятельно и за свой счет урегулировать указанные претензии.</p>
            <p>1.8. Пользователь обязуется использовать Сайт в соответствии с данным соглашением.</p>

            <p class="bold">2. Ограничение ответственности</p>
            <p>Администарция сайте не несет ответственности:</p>
            <p>2.1. За содержание материалов, опубликованных Пользователями.</p>
            <p>2.2. За причинение вреда, ущерба и любых других убытков, которые могут возникнуть при использовании Сайта.</p>

            <p class="bold">3. Права компании</p>
            <p>Администрация Сайта оставляет за собой право:</p>
            <p>3.1. Модифицировать Сайт по своему усмотрению.</p>
            <p>3.2. Редактировать или удалять материалы, опубликованные Пользователем на Сайте, если они не соответствуют условиям данного Соглашения, наносят вред Компании или третьим лицам, а также по своему личному усмотрению без указания причины.</p>
            <p>
              3.3. Использовать для материалы, опубликованные Пользователем на Сайте и находящиеся в открытом доступе, в частности, для размещения материалов на сайтах партнеров с целью помочь пользователю продвинуть себя в профессиональном плане.
            </p>
            <p>3.4. Вносить изменения в данное Соглашение в одностороннем порядке. Пользователь считается уведомленным о изменившихся условиях Соглашения с момента опубликования измененного варианта данного Соглашения на Сайте по адресу <a href="https://www.universtage.com/terms-and-condition">www.universtage.com/terms-and-condition</a></p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    created() {

    },
    data() {
      return {
        countriesList: [],
      }
    },
    computed: {
      ...mapGetters(['currentLng']),
    },
    methods: {
      testLng() {
        console.log(this.currentLng);
      }
    }
  }
</script>

<style scoped>
.terms-header {
  color: white;
  text-shadow: 1px 1px 1px black;
}
.card {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem;
    padding: 30px 25px 30px 25px;
    margin-bottom: 50px;
}
.container h4 {
  color: #565656 !important;
}
p {
  color: #565656 !important;
  margin-bottom: 15px;
}
.bold {
  font-weight: bold;
}
p a {
  color: #565656 !important;
  font-weight: 600;
}
</style>